/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CallForOpportunityPagedData } from '../../models/call-for-opportunity-paged-data';
import { SortType } from '../../models/sort-type';

export interface GetCallForOpportunities$Params {
  PageNumber?: number;
  PageSize?: number;
  StudentProfileId?: string;
  SortField?: string;
  SortType?: SortType;
}

export function getCallForOpportunities(http: HttpClient, rootUrl: string, params?: GetCallForOpportunities$Params, context?: HttpContext): Observable<StrictHttpResponse<CallForOpportunityPagedData>> {
  const rb = new RequestBuilder(rootUrl, getCallForOpportunities.PATH, 'get');
  if (params) {
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('StudentProfileId', params.StudentProfileId, {});
    rb.query('SortField', params.SortField, {});
    rb.query('SortType', params.SortType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CallForOpportunityPagedData>;
    })
  );
}

getCallForOpportunities.PATH = '/callforopportunity';
